/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { useRef } from 'react'

import Jazzicon from 'react-jazzicon'

import { useThemeContext } from 'src/contexts/ThemeContext'
import { shortenAddress } from 'src/functions/address/shortenAddress'
import { toSeedNumber } from 'src/functions/address/toSeedNumber'
import { useMediaScreenType } from 'src/hooks/useMediaScreenType'

import Avatar from '../Avatar'
import FlexBox from '../Common/FlexBox'
import Typeface from '../Common/Typeface'

type Props = {
  address: string
  noAvatar?: boolean
}

const AddressContainer = ({ address, noAvatar = false }: Props) => {
  const { colors } = useThemeContext()
  const { isMobile } = useMediaScreenType()

  const avatarRef = useRef<HTMLDivElement>(null)

  return (
    <FlexBox as="span" alignItems="center" columnGap={8}>
      {!noAvatar && (
        <Avatar ref={avatarRef} circular size={isMobile ? 16 : 22}>
          <Jazzicon diameter={avatarRef.current?.clientWidth} seed={toSeedNumber(address)} />
        </Avatar>
      )}

      <Typeface.Body color={colors.primary}>{shortenAddress(address)}</Typeface.Body>
    </FlexBox>
  )
}

export default AddressContainer
